import React, { useEffect, useState } from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { api } from "@/lib/api";
import { SEO } from "@/lib/seo";
import { CalendarDays, FileDown } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const fmt = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

export default function PressReleasesPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/press-releases").then(setItems).catch(() => {}); }, []);
  return (
    <main>
      <SEO title="Press Releases" description="Official CAF press releases and media statements." breadcrumbs={[{name: "Home", href:"/"},{name:"Media", href:"/media"},{name:"Press Releases", href:"/press-releases"}]} />
      <PageHeader eyebrow="Press Releases" title="For editors and journalists." lead="Verified releases, media contacts and downloadable PDFs." />
      <section className="container-wide py-12 grid gap-4">
        {items.map((p) => (
          <div key={p.id} className="flex flex-col md:flex-row md:items-center gap-4 rounded-2xl border border-border bg-background p-5 card-lift" data-testid={`press-card-${p.slug}`}>
            <div className="flex-1">
              <div className="flex items-center gap-2"><Badge className="badge-orange border">{p.category}</Badge><span className="text-xs text-[hsl(var(--muted-ink))] inline-flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" /> {fmt(p.published_at)}</span></div>
              <h3 className="heading-3 mt-2 text-lg">{p.title}</h3>
              <p className="text-sm text-[hsl(var(--muted-ink))] mt-2">{p.summary}</p>
            </div>
            <a href={p.pdf_url} className="btn-primary self-start md:self-auto"><FileDown className="h-4 w-4 mr-1.5" /> Download PDF</a>
          </div>
        ))}
      </section>
    </main>
  );
}
